export default {
    religion: [
        {
            code: "islam",
            label: "Islam",
        },
        {
            code: "kristen",
            label: "Kristen",
        },
        {
            code: "katholik",
            label: "Katholik",
        },
        {
            code: "hindu",
            label: "Hindu",
        },
        {
            code: "buddha",
            label: "Budha",
        },
    ],
};
